import React from 'react'

const RestaurantIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M2.91673 14L1.9834 13.0667L8.81673 6.23333C8.61673 5.76667 8.58895 5.23889 8.7334 4.65C8.87784 4.06111 9.19451 3.53333 9.6834 3.06667C10.2723 2.47778 10.9278 2.13333 11.6501 2.03333C12.3723 1.93333 12.9612 2.11111 13.4167 2.56667C13.8723 3.02222 14.0501 3.61111 13.9501 4.33333C13.8501 5.05556 13.5056 5.71111 12.9167 6.3C12.4501 6.78889 11.9223 7.10556 11.3334 7.25C10.7445 7.39444 10.2167 7.36667 9.75007 7.16667L8.91673 8L13.9834 13.0667L13.0501 14L7.9834 8.96667L2.91673 14ZM4.8834 8.3L2.8834 6.3C2.2834 5.7 1.9834 4.98333 1.9834 4.15C1.9834 3.31667 2.2834 2.6 2.8834 2L7.01673 6.16667L4.8834 8.3Z'
      fill='currentcolor'
    />
  </svg>
)

export default RestaurantIcon
